import * as React from "react";

function SvgCastle(props, ref) {
  return (
    <svg
      id="castle_svg__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 84 84"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {".castle_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2a21a4}"}
      </style>
      <g id="castle_svg__Brand">
        <g id="castle_svg__Brand-_x2F_-Legacy">
          <g id="castle_svg__Group-2">
            <g id="castle_svg__Group">
              <path
                id="castle_svg__Oval-1"
                className="castle_svg__st0"
                d="M42 79c20.4 0 37-16.6 37-37S62.4 5 42 5 5 21.6 5 42s16.6 37 37 37zm0 5c23.2 0 42-18.8 42-42S65.2 0 42 0 0 18.8 0 42s18.8 42 42 42z"
              />
              <g id="castle_svg__Icon" transform="translate(24.377 20.344)">
                <g id="castle_svg__Clip-30">
                  <path
                    id="castle_svg__path-1_1_"
                    className="castle_svg__st0"
                    d="M35.7 5.4v5l-5 5v18.4l5 5v5H.8v-5l5-5V15.3l-5-5V.3h5v5h5v-5h5v5h5v-5h5v5h5v-5h5v5.1zM18.2 17.5c-2.6 0-4.6 2-4.6 4.5v9h9.3v-9c0-2.5-2.1-4.5-4.7-4.5z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgCastle);
